import { useContext } from 'react';
import { LoadSettingContext } from '../utils';
export var useSetting = function useSetting(key) {
  var _a, _b;

  var settings = useContext(LoadSettingContext);

  if (settings) {
    return (_b = (_a = settings.find(function (e) {
      return e.key === key;
    })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : undefined;
  }

  return undefined;
};